import { render } from "./MainTemplate.vue?vue&type=template&id=07ce5b96&scoped=true"
import script from "./MainTemplate.vue?vue&type=script&lang=js"
export * from "./MainTemplate.vue?vue&type=script&lang=js"

import "./MainTemplate.vue?vue&type=style&index=0&id=07ce5b96&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ce5b96"]])

export default __exports__